import { LogItemLayout, LogItemProps } from '../LogItemLayout';
import { useTitle } from './useTitle';
import { useDetail } from './useDetail';
import { useStore } from './useStore';

export const LogItemTask = (props: LogItemProps) => {
  const { data } = props;

  const title = useTitle(data);
  const detail = useDetail(data);
  const store = useStore(data);

  return (
    <LogItemLayout
      {...props}
      title={title}
      before={detail?.before}
      after={detail?.after}
      removeStore={store?.removeStore}
      addStore={store?.addStore}
    />
  );
};
